import React from 'react';
import styled from 'styled-components';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';
import { VisualPickerButton } from '../../../CommonComponents/OPL/VisualPickerButton/VisualPickerButton';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { SelectHouseholdMemberModalLoading } from './SelectHouseholdMemberModal.loading';
import { useDocumentVaultContext } from '../../context/useDocumentVaultContext';
import { useFidelityTokenId } from '../../hooks/useFidelityTokenId';
import { useNavigate } from '../../hooks/useNavigate';
import { toast } from '../../../CommonComponents/OPL/Toast/Toast';
import { useFidelityAvailableUsersListQuery } from '../../api/useFidelityAvailableUsersQuery';

const Grid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 16,
});

export const SelectHouseholdMemberModal = () => {
  const { data, isLoading } = useFidelityAvailableUsersListQuery();

  const { selectedEntity, setSelectedEntity } = useDocumentVaultContext();

  const { setCurrentTokenId } = useFidelityTokenId();

  const navigate = useNavigate();

  const onRequestClose = () => {
    setSelectedEntity(null);
  };

  if (isLoading) {
    return <SelectHouseholdMemberModalLoading onRequestClose={onRequestClose} />;
  }

  if (!data || !selectedEntity) {
    return null;
  }

  return (
    <Modal
      contentLabel="Select Household Member"
      isOpen
      shouldCloseOnOverlayClick={false}
      size="small"
      onRequestClose={onRequestClose}
    >
      <ModalHeader>Select Household Member</ModalHeader>
      <ModalCloseButton onClick={onRequestClose} />

      <ModalBody>
        <Grid>
          {data.map(householdMember => (
            <VisualPickerButton
              key={householdMember.id}
              icon="fas fa-home"
              onClick={() => {
                setCurrentTokenId(householdMember.id);

                navigate({
                  path: encodeURIComponent(selectedEntity.path),
                  providerType: selectedEntity.providerType,
                  filterableByYear: selectedEntity.filterableByYear,
                });

                toast.success('Household member has been selected');
              }}
            >
              {householdMember.name}
            </VisualPickerButton>
          ))}

          <VisualPickerButton
            icon="far fa-plus"
            onClick={() => {
              setSelectedEntity({ ...selectedEntity, forceUserAuthentication: true });
            }}
          >
            Add New Household Member
          </VisualPickerButton>
        </Grid>
      </ModalBody>
    </Modal>
  );
};
